import { AlarmClock, MoonStar } from "lucide-react";
import { Reveal } from "./Reveal";
import { Squiggle, SmileyDoodle, StarDoodle } from "./doodles";
import { scrollToSection } from "@/config/station";

const SCHEDULE = [
    {
        id: "morning",
        icon: AlarmClock,
        chip: "bg-sunny",
        title: "Morning Broadcast",
        days: "Every day",
        time: "9:00 AM – 11:00 AM",
        zone: "Central Time",
    },
    {
        id: "night",
        icon: MoonStar,
        chip: "bg-ink",
        title: "Night Replay",
        days: "Every day",
        time: "9:00 PM – 11:00 PM",
        zone: "Central Time",
    },
];

export default function SnoozeButton() {
    return (
        <section
            id="snooze-button"
            data-testid="snooze-button-section"
            className="relative overflow-hidden border-b-[2.5px] border-ink bg-sunny py-16 sm:py-24"
        >
            <StarDoodle className="absolute left-[5%] top-10 hidden h-7 w-7 lg:block" fill="#FAF7EE" />
            <StarDoodle className="absolute bottom-12 right-[6%] hidden h-6 w-6 lg:block" fill="#FF70A6" />

            <div className="mx-auto max-w-5xl px-4 text-center sm:px-6">
                <Reveal>
                    <span className="sticker bg-ink !text-sunny">02 · The Flagship Show</span>
                    <h2 className="mt-4 font-marker text-[clamp(2.2rem,7.5vw,4.5rem)] leading-[1.05] tracking-tight text-ink">
                        THE SNOOZE BUTTON
                    </h2>
                    <p className="mt-2 -rotate-1 font-hand text-3xl font-bold text-ink sm:text-4xl">
                        Wake Up. Tune In. Stay Inspired.
                    </p>
                    <Squiggle className="mx-auto mt-3 h-3 w-36" stroke="#1A1918" />
                    <p className="mx-auto mt-4 max-w-2xl text-base leading-relaxed text-ink sm:text-lg">
                        Your daily dose of independent hip-hop, artist discoveries, real
                        conversations, and inspiration. Join us every morning on Inspiration
                        Station.
                    </p>
                </Reveal>

                <div className="mx-auto mt-10 grid max-w-3xl grid-cols-1 gap-5 sm:grid-cols-2">
                    {SCHEDULE.map((s, i) => {
                        const Icon = s.icon;
                        return (
                            <Reveal key={s.id} delay={0.1 + i * 0.08}>
                                <div
                                    data-testid={`schedule-card-${s.id}`}
                                    className="sticker-hover card-hard flex h-full flex-col items-center bg-cream p-6"
                                >
                                    <span
                                        className={`flex h-12 w-12 items-center justify-center rounded-xl border-2 border-ink ${s.chip}`}
                                    >
                                        <Icon
                                            className={`h-6 w-6 ${s.id === "night" ? "text-cream" : "text-ink"}`}
                                            strokeWidth={2.5}
                                        />
                                    </span>
                                    <h3 className="mt-4 font-condensed text-2xl font-black uppercase tracking-wide text-ink">
                                        {s.title}
                                    </h3>
                                    <p className="mt-2 font-mono2 text-xs font-bold uppercase tracking-[0.18em] text-ink2">
                                        {s.days}
                                    </p>
                                    <p className="mt-1 font-condensed text-xl font-extrabold text-ink">
                                        {s.time}
                                    </p>
                                    <p className="font-mono2 text-xs text-ink2">{s.zone}</p>
                                </div>
                            </Reveal>
                        );
                    })}
                </div>

                <Reveal delay={0.25}>
                    <button
                        data-testid="snooze-listen-button"
                        onClick={() => scrollToSection("listen-live")}
                        className="btn-ink mt-8 bg-white text-xl hover:bg-creamalt !px-8 !py-4"
                    >
                        Listen on the Station Player
                    </button>
                    <div className="mt-6 flex items-center justify-center gap-3">
                        <SmileyDoodle className="h-9 w-9" fill="#FAF7EE" />
                        <p
                            data-testid="snooze-schedule-note"
                            className="max-w-md text-left font-mono2 text-xs leading-relaxed text-ink"
                        >
                            All times Central. This is the station's programming plan — the rest of
                            the day is music rotation, station IDs, and promos. Follow the socials
                            for schedule updates.
                        </p>
                    </div>
                </Reveal>
            </div>
        </section>
    );
}
